/* KonpreShop · Menú «plazas» (2-nov-2026)
   Escritorio: abre el panel de cada tienda con el ratón (espera corta para no abrir al pasar de largo; si ya hay uno
   abierto, cambia al instante), con la flechita (clic, toque, Enter o Espacio), con flecha abajo desde el nombre,
   y lo cierra con Escape, al salir, al tocar fuera o al mover el foco fuera. Marca la tienda en la que estás.
   Cajón: lleva el foco al botón de cerrar al abrir, lo regresa a la hamburguesa al cerrar y no deja que el tabulador se salga. */
(function () {
  'use strict';
  var header = document.querySelector('.site-header');
  if (!header || header.hasAttribute('data-ksn')) return;
  header.setAttribute('data-ksn', '');

  var desk = window.matchMedia('(min-width: 1101px)');
  var items = [].slice.call(header.querySelectorAll('.nav-links .nav-item'));
  var OPEN_DELAY = 90, CLOSE_DELAY = 200;
  var open = null, openedBy = '', tOpen = 0, tClose = 0;

  function panelOf(it) { return it.querySelector(':scope > .mega-menu, :scope > .dropdown--sm'); }
  function btnOf(it) { return it.querySelector(':scope > .ksn-more'); }
  function isMega(it) { var p = panelOf(it); return !!(p && p.classList.contains('mega-menu')); }

  function setOrigin(it) {
    var p = panelOf(it);
    if (!p || !isMega(it)) return;
    var a = it.getBoundingClientRect(), b = p.getBoundingClientRect();
    if (!b.width) return;
    p.style.setProperty('--ksn-origin', Math.round(a.left + a.width / 2 - b.left) + 'px 0px');
  }
  function instant() {
    header.classList.add('ksn-instant');
    requestAnimationFrame(function () { requestAnimationFrame(function () { header.classList.remove('ksn-instant'); }); });
  }
  function hide(it, swapping) {
    if (!it) return;
    it.classList.remove('is-open');
    var b = btnOf(it);
    if (b) b.setAttribute('aria-expanded', 'false');
    if (open === it) { open = null; openedBy = ''; }
    if (!swapping) header.classList.remove('ksn-open');
  }
  function show(it, how) {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (open === it) { if (how !== 'hover') openedBy = how; return; }
    if (open) { instant(); hide(open, true); }
    setOrigin(it);
    it.classList.add('is-open');
    var b = btnOf(it);
    if (b) b.setAttribute('aria-expanded', 'true');
    header.classList.toggle('ksn-open', isMega(it));
    open = it; openedBy = how || '';
  }
  function closeAll() { clearTimeout(tOpen); clearTimeout(tClose); if (open) hide(open); }

  header.classList.add('ksn-ready');

  items.forEach(function (it) {
    var panel = panelOf(it), btn = btnOf(it), link = it.querySelector(':scope > a');

    it.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !desk.matches) return;
      clearTimeout(tClose);
      if (!panel) { // MaquilaDTF: no tiene panel; si había uno abierto, se cierra pronto
        if (open && openedBy === 'hover') { clearTimeout(tOpen); tClose = setTimeout(closeAll, 120); }
        return;
      }
      if (open && open !== it) { show(it, 'hover'); return; }
      if (!open) { clearTimeout(tOpen); tOpen = setTimeout(function () { show(it, 'hover'); }, OPEN_DELAY); }
    });
    it.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(tOpen);
      if (open === it && openedBy === 'hover') tClose = setTimeout(function () { hide(it); }, CLOSE_DELAY);
    });

    if (!panel) return;

    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (open === it && openedBy === 'hover') { openedBy = 'click'; return; } // ya lo abrió el ratón: el clic lo deja fijo
      if (open === it) hide(it); else show(it, 'click');
    });

    it.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open === it) {
        e.preventDefault(); e.stopPropagation();
        hide(it);
        (btn || link).focus();
      } else if (e.key === 'ArrowDown' && (e.target === btn || e.target === link)) {
        e.preventDefault();
        show(it, 'key');
        var first = panel.querySelector('a[href]');
        if (first) first.focus();
      }
    });
    it.addEventListener('focusout', function (e) {
      if (open === it && e.relatedTarget && !it.contains(e.relatedTarget)) hide(it);
    });
  });

  document.addEventListener('pointerdown', function (e) {
    if (open && !open.contains(e.target)) hide(open);
  });
  if (desk.addEventListener) desk.addEventListener('change', closeAll); else if (desk.addListener) desk.addListener(closeAll);
  window.addEventListener('pagehide', closeAll);

  /* ---------- la tienda en la que estás ---------- */
  function norm(p) { return (p || '').replace(/\/+$/, '') || '/'; }
  var here = norm(location.pathname);
  var skip = /\/pages\/(contacto|quienes-somos|nosotros|faq|terminos|politica)|\/policies\//;
  var current = null, exact = false;
  items.some(function (it) {
    var key = it.getAttribute('data-ksn-plaza');
    if (!key || key === 'nosotros') return false;
    return [].slice.call(it.querySelectorAll('a[href]')).some(function (a) {
      var p = norm(a.pathname);
      if (skip.test(p) || p === '/') return false;
      if (p === here) { current = it; exact = (a === it.querySelector(':scope > a')); return true; }
      return false;
    });
  });
  if (current) {
    current.classList.add('is-current');
    var cl = current.querySelector(':scope > a');
    if (cl) cl.setAttribute('aria-current', exact ? 'page' : 'true');
    var drawerKey = { outlet: 'moPanelOutlet', fragancia: 'moPanelFragancia', cap: 'moPanelCap', uniforme: 'moPanelUniforme', sport: 'moPanelSport', invierno: 'moPanelPreventa' }[current.getAttribute('data-ksn-plaza')];
    var row = drawerKey ? document.querySelector('#mobileNav [data-mo-open="' + drawerKey + '"]')
      : (current.getAttribute('data-ksn-plaza') === 'maquila' ? document.querySelector('#mobileNav a.mo-row[href$="pages/maquiladtf"]') : null);
    if (row) { row.classList.add('is-current'); row.setAttribute('aria-current', 'true'); }
  }

  /* ---------- cajón: foco ---------- */
  var drawer = document.getElementById('mobileNav');
  var toggle = header.querySelector('.nav-toggle');
  if (drawer && window.MutationObserver) {
    var was = document.body.classList.contains('nav-open');
    new MutationObserver(function () {
      var now = document.body.classList.contains('nav-open');
      if (now === was) return;
      was = now;
      if (now) {
        setTimeout(function () { var c = drawer.querySelector('.mo-close'); if (c) c.focus({ preventScroll: true }); }, 60);
      } else if (toggle && (drawer.contains(document.activeElement) || document.activeElement === document.body)) {
        toggle.focus({ preventScroll: true });
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !document.body.classList.contains('nav-open')) return;
      var f = [].slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input, summary')).filter(function (el) {
        if (el.closest('[style*="display:none"]')) return false;
        var r = el.getBoundingClientRect();
        var d = drawer.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && r.left >= d.left - 1 && r.right <= d.right + 1 && getComputedStyle(el).visibility !== 'hidden';
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
})();
